import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewChild,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TextComponent } from '../../../../../../lss-ui/src/lib/form/text/text.component';

@Component({
  selector: 'lss-certificate-item',
  templateUrl: './certificate-item.component.html',
  styleUrls: ['./certificate-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CertificateItemComponent implements AfterViewInit {
  @Input() formGroup: FormGroup;
  @Input() focusElement = false;
  @ViewChild('focusField') focusField: TextComponent;

  ngAfterViewInit(): void {
    if (this.focusElement && this.focusField) {
      this.focusField.focusInput();
    }
  }
}
